// extracted by mini-css-extract-plugin
module.exports = {"animatedMask":"animatedMask-3Tx7h","placeHolderShimmer":"placeHolderShimmer-3LfdJ"};